interface ActionTypes {
  QUERY_FEATURE_LAYER_EXTENT_START: string;
  QUERY_FEATURE_LAYER_EXTENT_SUCCESS: string;
  QUERY_FEATURE_LAYER_EXTENT_FAILURE: string;
  QUERY_CLUSTER_EXTENT_START: string;
  QUERY_CLUSTER_EXTENT_SUCCESS: string;
  QUERY_CLUSTER_EXTENT_FAILURE: string;
}

export const MapLocalActionTypes: ActionTypes = {
  QUERY_FEATURE_LAYER_EXTENT_START: '@@QUERY_FEATURE_LAYER_EXTENT_START',
  QUERY_FEATURE_LAYER_EXTENT_SUCCESS: '@@QUERY_FEATURE_LAYER_EXTENT_SUCCESS',
  QUERY_FEATURE_LAYER_EXTENT_FAILURE: '@@QUERY_FEATURE_LAYER_EXTENT_FAILURE',
  QUERY_CLUSTER_EXTENT_START: '@@QUERY_CLUSTER_EXTENT_START',
  QUERY_CLUSTER_EXTENT_SUCCESS: '@@QUERY_CLUSTER_EXTENT_SUCCESS',
  QUERY_CLUSTER_EXTENT_FAILURE: '@@QUERY_CLUSTER_EXTENT_FAILURE'
};

export interface MapLocalState {
  featureLayerExtent?: any;
  clusterExtent?: any;
  resultCount?: number;
}

export default MapLocalActionTypes;
